import { Listbox, Transition } from '@headlessui/react'
import React, { useState, Fragment } from 'react'
import { ChromePicker } from 'react-color';
import { Oval } from  'react-loader-spinner'
import config from '../../../../../../config';

export default function LeaderboardDesign({
    auctionData,
    setAuctionData,
    setEditedAuctionData,
    handleLogoChange,
    handleLogoDelete,
    eventDisplayImageLoader
}) {
    const [showBgColorPicker, setShowBgColorPicker] = useState(false);
    const [colorShow, setColorShow] = useState(auctionData.event_display.background_color !== "");

    return (
        <div className="px-2 pt-5">
            {/* <!-- color or image select --> */}
            <Listbox as="div" className="relative w-full"
                value={colorShow ? 'Colour' : 'Image'} 
                onChange={(value) => {
                    setColorShow(value === 'Colour' ? true : false)
                }}
            >
                <div className="flex mt-4">
                    <p className="text-[12px] font-medium leading-normal text-[#343434]">Background</p>
                </div>
                <Listbox.Button type="button" id="bgDropdown"
                    className={`text-[14px] text-start relative w-full h-11 px-3 border 
                    border-[#A1A1A9] ${colorShow?'text-[#343434]':'text-[#A1A1A9]'} 
                    outline-none font-medium leading-normal hover:border-[#343434] transition-colors`}
                    data-te-dropdown-toggle-ref
                    aria-expanded="false"
                    data-te-ripple-init
                    data-te-ripple-color="light"
                >
                    {colorShow ? 'Colour' : 'Image'}
                </Listbox.Button>
                <img src="/images/dropdown-icon.png" alt="dropdown-icon"
                    className="absolute top-[40px] right-[15px]"
                />
                <Listbox.Options 
                    className="bg-white rounded-[8px] z-30  absolute w-full 
                    [&[data-te-dropdown-show]]:block  shadow-bs1" aria-labelledby="dropdownMenuButton2"
                    data-te-dropdown-menu-ref>
                    <Transition
                        as={Fragment}
                        leave='transition ease-in duration-100'
                        leaveFrom='opacity-100'
                        leaveTo='opacity-0'>
                        <div className=" pr-[10px] pl-[10px] py-2 h-[80px] customScrollbar 
                                overflow-y-auto overflow-x-hidden ">
                            {['Colour', 'Image'].map((option, index)=>(
                                <Listbox.Option key={option} value={option}
                                    as="div" 
                                    className="pl-[10px] pr-[10px] text-[12px] h-8 flex items-center
                                        cursor-pointer leading-normal font-medium text-[#343434] 
                                        hover:bg-[#E6E6E6] transition-colors"
                                    data-testid={`bgOption-${option}`}
                                >
                                    {() => option}
                                </Listbox.Option>
                            ))}
                        </div>
                    </Transition>
                </Listbox.Options>
            </Listbox>
            {/* <!-- color content --> */}
            {colorShow && (
                <div className="flex pt-4">
                    <div onClick={()=>setShowBgColorPicker(true)} 
                        className="w-[30px] h-[22px] border border-[#282828] bg-[#343434] rounded-[4px] cursor-pointer 
                        hover:border-[#000] transition-colors"
                        style={{ backgroundColor: auctionData.event_display.background_color }}
                        data-testid="bgColorPicker">
                    </div>
                    <p className="font-medium text-[#343434] text-[12px] pl-[10px] leading-normal">
                        Background colour
                    </p>
                </div>
            )}
            {showBgColorPicker && (
                <div>
                    <div className='fixed top-0 left-1 right-0 w-full h-full' 
                        onClick={()=> setShowBgColorPicker(false) }
                    />
                    <ChromePicker color={ auctionData.event_display.background_color } 
                        onChange={(updatedColor) => {
                            setAuctionData(prevData => ({
                                ...prevData,
                                event_display: {
                                    ...prevData.event_display,
                                    background_color: updatedColor.hex
                                }
                            }))
                            setEditedAuctionData(prevData => ({
                                ...prevData,
                                event_display: {
                                    ...prevData.event_display,
                                    background_color: updatedColor.hex
                                }
                            }))
                        }}
                    />
                </div>
            )}
            {/* <!-- image content --> */}
            {!colorShow && auctionData.event_display.background_image === '' && (
                <div className="w-full flex justify-center relative bg-[#E6E6E6] py-[22px] px-3 mt-2 rounded-md cursor-pointer 
                hover:bg-[#d6d6d6] transition-colors">
                    <img src="/images/add-image-icon.svg" alt="logo-preview" loading="lazy" />
                    <label
                        htmlFor="auctionUpload"
                        className="font-medium text-center pl-2 text-[#343434] text-[10px] leading-normal cursor-pointer"
                    >
                        {"Add image"}
                    </label>
                    <input
                        type="file"
                        data-testid='bgUpload'
                        accept="image/jpeg, image/png, image/gif"
                        id="auctionUpload"
                        className="opacity-0 z-10 absolute cursor-pointer top-0 h-[58px] w-full"
                        onChange={(e)=>handleLogoChange(e, "event_display_image")}
                    />
                    {eventDisplayImageLoader && (
                        <Oval
                            height={20}
                            width={50}
                            color="#FFFFFF"
                            wrapperClass=""
                            visible={true}
                            ariaLabel='oval-loading'
                            secondaryColor="#000000"
                            strokeWidth={2}
                            strokeWidthSecondary={2}
                        />
                    )}
                </div>
            )}
            {!colorShow && auctionData.event_display.background_image !== '' && (
                <div className="w-full flex h-[84px] justify-center items-center relative bg-[#E6E6E6] px-3 mt-2 rounded-md">
                    <img
                        src={auctionData.event_display.background_image.startsWith('blob:') 
                            ? auctionData.event_display.background_image : 
                            `${config.Storage.CDN}${auctionData.event_display.background_image}`}
                        alt="add-image-icon"
                        className='w-[125px] h-[65px]'
                        loading="lazy"
                    />
                    {eventDisplayImageLoader && (
                        <div className='absolute left-[43%]' >
                            <Oval
                                height={25}
                                width={55}
                                color="#FFFFFF"
                                wrapperClass=""
                                visible={true}
                                ariaLabel='oval-loading'
                                secondaryColor="#000000"
                                strokeWidth={2}
                                strokeWidthSecondary={2}
                            />
                        </div>
                    )}
                    <div className="flex justify-end absolute right-[15px] bottom-[15px] z-[11]">
                        <label
                            htmlFor="auctionUpload"
                            className="font-medium text-center pr-2 h-auto text-[#343434] 
                                text-[10px] leading-normal cursor-pointer hover:opacity-70 transition-opacity"
                        >
                            <img src="/images/edit-icon-img.svg" 
                                className="cursor-pointer w-3.5 hover:opacity-70 transition-opacity" alt="edit" loading="lazy" />
                        </label>
                        <input 
                            type="file"
                            accept="image/jpeg, image/png, image/gif"
                            id="auctionUpload"
                            className="opacity-0 absolute cursor-pointer top-0 w-3 left-0 z-[-1]"
                            onChange={(e) => handleLogoChange(e,'event_display_image')}
                        />
                        <img
                            src="/images/delete-icon-img.svg" 
                            id ="delete-icon"
                            className="cursor-pointer hover:opacity-70 transition-opacity"
                            alt="delete"
                            onClick={() => handleLogoDelete("event_display_image")}
                            loading="lazy"
                        />
                    </div>
                </div>
            )}
        </div>
    )
}
